<template>
  <div
    v-if="GET_ACCOUNT_DATA.group_id == 1 || has_perm('view_case')"
    style="border: 0px solid black; width:100%;"
  >
    <div class="welcome" style="border: 0px solid red;">
      <row
        style="border:0px solid green;position: inherit;display:contents;width:100%;"
      >
        <!-- Search container -->
        <div class="box box-success">
          <div class="box-header with-border">
            <h3 class="box-title">{{ $t("search.title") }}</h3>
          </div>
          <div class="box-body">
            <div class="row" style="margin-bottom: 10px;">
              <div class="col-sm-3 col-md-3 col-lg-3">
                <input
                  type="text"
                  class="form-control"
                  :placeholder="$t('case.code')"
                  v-model="search.code"
                  @keydown.enter="onSearchCase($event)"
                />
              </div>
              <div class="col-sm-3 col-md-3 col-lg-3">
                <input
                  type="text"
                  class="form-control"
                  :placeholder="$t('case.casetitle')"
                  v-model="search.title"
                  @keydown.enter="onSearchCase($event)"
                />
              </div>
              <!-- <div class="col-sm-3 col-md-3 col-lg-3">
                <input
                  type="text"
                  class="form-control"
                  :placeholder="$t('case.type')"
                  v-model="search.type_case"
                  @keydown.enter="onSearchCase($event)"
                />
              </div> -->
              <div class="col-sm-3 col-md-3 col-lg-3">
                <div class="input-group">
                  <span class="input-group-addon">
                    <i class="fa fa-user"></i>
                  </span>
                  <input
                    type="text"
                    class="form-control"
                    :placeholder="$t('case.assignto')"
                    v-model="search.person_in_charge"
                    @keydown.enter="onSearchCase($event)"
                  />
                </div>
              </div>
              <div style="margin-right: 15px">
                <button
                  type="button"
                  class="btn btn-labeled btn-success pull-right"
                  @click="onSearchCase($event)"
                >
                  <span class="btn-label">
                    <i class="glyphicon glyphicon-search"></i>
                  </span>
                  {{ $t("search.search_button") }}
                </button>
              </div>
            </div>
            <!-- <div class="row" style="margin-bottom: 10px;">
              <div class="col-sm-3 col-md-3 col-lg-3">
                <input
                  type="text"
                  class="form-control"
                  :placeholder="$t('case.subtype')"
                  v-model="search.type_sub_case"
                />
              </div>
             
            </div>-->
          </div>
        </div>
        <!--  -->
        <!-- <div class="box box-primary">
          <div class="box-header with-border"> -->
        <!--  -->
        <div class="">
          <div class="panel with-nav-tabs panel-primary">
            <div class="panel-heading">
              <ul class="nav nav-tabs">
                <li class="active">
                  <a href="#tab1primary" data-toggle="tab">{{
                    $t("case.title")
                  }}</a>
                </li>
                <!-- <li>
                  <a href="#tab2primary" data-toggle="tab">{{
                    $t("feedback.config.title")
                  }}</a>
                </li> -->
              </ul>
            </div>
            <div class="panel-body">
              <div class="tab-content">
                <div class="tab-pane fade in active" id="tab1primary">
                  <div class="box-header with-border">
                    <row style="margin: 0">
                      <div
                        style="text-align:center; font-size: 17px;text-align:left;color:#5b6c7f;margin-bottom:20px;"
                      >
                        <lte-button
                          style="float:right"
                          type="btn btn-primary"
                          right_icon="fa fa-plus"
                          v-if="
                            has_perm('create_case') ||
                              GET_ACCOUNT_DATA.group_id == 1
                          "
                          @click="addNew($event)"
                          >{{ $t("case.addnew") }}</lte-button
                        >
                      </div>
                    </row>
                    <!-- <div class="col-md-12" style="padding: 0">
                      <select-option-check
                        @callbackData="onColumnSelect"
                        :item="columnsCase"
                        class="dropdown-trigger"
                        data-icon="eye"
                      ></select-option-check>
                    </div> -->
                  </div>
                  <div class="box-body">
                    <div class="row">
                      <div class="col-md-12">
                        <div class="" style="display: flex; padding: 0 15px">
                        <span
                          v-for="(item, index) in feedbackTabs"
                          :key="item + index"
                          :class="
                            `${
                              index !== feedbackTabs.length - 1
                                ? 'customer-type-class border-right'
                                : 'customer-type-class'
                            }`
                          "
                          @click="onChangeTab(item.value)"
                        >
                          <span
                            :class="
                              item.value === feedbackTabSelect
                                ? 'customer-type-select'
                                : ''
                            "
                            style="white-space: nowrap;"
                          >
                            {{ $t(item.text) }}
                            <!-- {{ item.value !== null ? `(${item.total})` : null }} -->
                          </span>
                        </span>
                      </div>
                      </div>
                      <div class="col-md-12">
                        <b-table
                          :items="gridCaseDataList"
                          :fields="gridColumns"
                          class="mt-3"
                          responsive
                          outlined
                        >
                          <template #head()="scope">
                            <div>{{ $t(scope.label) }}</div>
                          </template>
                          <template #cell(code)="row">
                            <span>{{ $t(row.item.code) }}</span>
                            <div class="action-class">
                              <span
                                v-if="
                                  getShowInteractAction(
                                    row.item.statusValue,
                                    row.item.assigntoId,
                                    row.item.depatmentData
                                  ) || row.item.isActionInteract
                                "
                                class="interact-action-class"
                                @click="interactAction(row.item.id)"
                                ><small>{{ $t("common.interact") }}</small></span
                              >
                            </div>
                          </template>
                          <template #cell(status)="row">
                            <span :style="`color: ${getStatusColor(row.item.statusValue)}`">{{ $t(row.item.status) }}</span>
                          </template>
                          <template slot="assignto" slot-scope="row">
                            <span v-html="row.item.assignto"></span>
                          </template>
                          <template #cell(actions)="row">
                            <div class="btn-group">
                              <button
                                type="button"
                                class="btn btn-danger dropdown-toggle"
                                data-toggle="dropdown"
                                aria-expanded="true"
                              >
                                <i class="fa fa-fw fa-ellipsis-h"></i>
                              </button>
                              <ul
                                class="dropdown-menu"
                                style="min-width: 50px;height: 80px;"
                              >
                                <li>
                                  <button
                                    v-if="
                                      GET_ACCOUNT_DATA.group_id == 1 ||
                                        has_perm('update_case')
                                    "
                                    class="btn btn-primary btn-sm"
                                    style="margin-left: 6px;"
                                    @click="onOpenEditInput(row)"
                                  >
                                    <i class="glyphicon glyphicon-edit"></i>
                                  </button>
                                </li>
                                <li>
                                  <button
                                    v-if="
                                      GET_ACCOUNT_DATA.group_id == 1 ||
                                        has_perm('delete_case')
                                    "
                                    class="btn btn-danger btn-sm"
                                    style="margin-left: 6px;"
                                    @click="onOpenDelete(row)"
                                  >
                                    <i class="glyphicon glyphicon-trash"></i>
                                  </button>
                                </li>
                              </ul>
                            </div>
                          </template>
                        </b-table>
                      </div>
                    </div>
                  </div>
                  <div class="box-footer clearfix" style="display:contents;">
                    <paginator
                      :totalItem="paginateData.totalItem"
                      :currentPage="paginateData.currentPage"
                      :pageSize="paginateData.pageSize"
                      :totalPage="paginateData.totalPage"
                      @onpaginate="onPagination"
                    />
                  </div>
                </div>
                <!-- <div class="tab-pane fade" id="tab2primary">
                  <config-department-and-subject></config-department-and-subject>
                </div> -->
              </div>
            </div>
          </div>
        </div>
        <!--  -->
        <!-- </div>
        </div> -->
        <!--  -->

        <lte-modal
          v-show="isModalVisible"
          @onConfirm="onConfirm"
          @close="closeModal"
          v-for="obj in objModal"
          :key="obj.id"
          :item="obj"
        ></lte-modal>
        <lte-core-alert
          v-for="snackbar in GET_SNACK_BAR"
          :key="snackbar.id"
          :item="snackbar"
        ></lte-core-alert>
        <loading
          :active.sync="isLoading"
          :can-cancel="false"
          color="#1E90FF"
        ></loading>
      </row>
    </div>
    <!-- /.modal -->
    <feedback-interact-modal
      ref="feedbackInteractModal"
      @callbackFeedback="callbackFeedback"
    />
  </div>
</template>
<script>
import Paginator from "@/components/CustomPaginator.vue";
import { mapGetters, mapActions } from "vuex";
import LTEButton from "@/components/LTEButton.vue";
// import { LTEActionTypeEnum } from '@/components/LTEEnum'
// import LTETable from "@/components/LTETable.vue";
import LTEModal from "@/components/LTEModal.vue";
import LTECoreAlert from "@/components/LTESnackBar.vue";
import utils from "@/lib/utils";
import Loading from "vue-loading-overlay";
import constants from "@/lib/constantsData";
// import SelectOptionCheck from "@/components/SelectOptionCheck.vue";
// import ConfigDepartmentAndSubject from "./ConfigDepartmentAndSubject";
import FeedbackInteractModal from "./FeedbackInteractModal";
import privilegeRoleEnum from "@/enum/PrivilegeRoleEnum";
import feedbackStatusEnum from "@/enum/feedbackStatusEnum";

export default {
  name: "CaseList",
  data() {
    return {
      buttonName: "danger",
      labelName: "Name",
      groupUserID: 4,
      pkg_tmpl_data: {
        id: 0
      },
      feedbackTabs: [
        {
          value: 1,
          text: "managementServiceOrder.statusList.unfinished",
          total: 0
        },
        {
          value: null,
          text: "common.history",
          total: 0
        }
      ],
      feedbackTabSelect: 1,
      feedbackStatusFilterList: [
        feedbackStatusEnum.CREATE,
        feedbackStatusEnum.RECEIVED,
        feedbackStatusEnum.IN_PROGRESS,
        feedbackStatusEnum.IN_PROGRESS_DOING,
        feedbackStatusEnum.IN_PROGRESS_DONE,
        feedbackStatusEnum.IN_PROGRESS_CANCEL
      ],
      gridCaseDataList: [],
      useFilter: false,
      boxStyle: false,
      gridColumns: [
        {
          label: "common.nonumber",
          key: "nonumber",
          sortable: true,
          class: "text-center "
        },
        {
          label: "common.code",
          key: "code",
          sortable: true,
          class: "text-center "
        },
        {
          label: "case.casetitle",
          key: "casetitle",
          sortable: true,
          class: "text-center "
        },
        {
          label: "feedback.apartmentCode",
          key: "apartmentCode",
          sortable: true,
          class: "text-center "
        },
        {
          label: "feedback.user_created",
          key: "user_created",
          sortable: true,
          class: "text-center "
        },
        {
          label: "case.opendate",
          key: "opendate",
          sortable: true,
          class: "text-center "
        },
        {
          label: "case.status",
          key: "status",
          sortable: true,
          class: "text-center "
        },
        {
          label: "case.assignto",
          key: "assignto",
          sortable: true,
          class: "text-center "
        },
        { key: "actions", label: "common.action", sortable: false }
      ],
      columnsCase: {
        data_list: [],
        itemType: 1,
        showLabel: false,
        modifyFromPosition: "margin-top:-300px",
        cssClassSm1: "col-md-1",
        cssClassSm2: "col-sm-1",
        showAddNew: false
      },
      originalRecordData: [],
      isModalVisible: false,
      objModal: [
        {
          title: "common.delete_modal.title",
          body: "common.delete_modal.content",
          buttonNo: "common.delete_modal.btnNo",
          buttonYes: "common.delete_modal.btnYes",
          styleType: "default"
        }
      ],
      dateOptions: {
        format: "YYYY-MM-DD hh:mm a"
      },
      dateOptionsNoTime: {
        format: "DD-MM-YYYY"
      },
      search: {
        code: "",
        title: "",
        type_case: "",
        type_sub_case: "",
        person_in_charge: ""
      },
      isLoading: false,
      feedbackStatusList: constants.feedbackStatusList,
      paginateData: {
        totalItem: 1,
        currentPage: 1,
        pageSize: 1,
        totalPage: 1
      },
      privilegeRoleEnum: privilegeRoleEnum,
      feedbackStatusEnum: feedbackStatusEnum
    };
  },
  watch: {
    GET_LANG: function() {
      this.getFeedbackList(1);
    },
    GET_FEEDBACK_LIST_DATA: function() {
      let paginate = this.GET_FEEDBACK_LIST_DATA.paginate;
      this.paginateData = {
        totalItem: paginate.totalItem,
        currentPage: paginate.currentPage,
        pageSize: paginate.pageSize,
        totalPage: paginate.numPages
      };
      this.gridCaseDataList = [];
      this.GET_FEEDBACK_LIST_DATA.results.forEach((feedbackData, i) => {
        let id = feedbackData.id;
        let nonumber =
          i + 1 + (this.PAGINATION.page - 1) * this.PAGINATION.size;
        let code = feedbackData.code;
        let casetitle = feedbackData.title;
        let userCreated = feedbackData.user_created.full_name;
        let apartmentCode = feedbackData.apartment.apartment_code;
        let opendate = utils.formatSqlDate(feedbackData.date_created, null, "HH:mm DD/MM/YYYY");
        let assignTo =
          feedbackData.assign_to && feedbackData.assign_to.full_name;
        let assigntoId = feedbackData.assign_to && feedbackData.assign_to.id;
        let data = {
          id: id,
          code: code,
          nonumber: nonumber,
          casetitle: casetitle,
          user_created: userCreated,
          apartmentCode: apartmentCode,
          opendate: opendate,
          status: this.getStatusName(feedbackData.status),
          statusValue: feedbackData.status,
          assignto: assignTo,
          assigntoId: assigntoId,
          isActionInteract: feedbackData.is_action_interact,
          depatmentData: feedbackData.department_data
        };
        this.gridCaseDataList.push(data);
      });
    },
    GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA: function() {
      // if (!utils.isNull(this.GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA.data)) {
      //   let newGridColumns = [];
      //   const viewedColumnsKey = Object.keys(
      //     this.GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA.data.viewed_columns
      //   );
      //   const viewedColumns = this.GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA.data
      //     .viewed_columns;
      //   for (
      //     let j = 0, sizeOrigin = this.gridColumns.length;
      //     j < sizeOrigin;
      //     j++
      //   ) {
      //     for (let i = 0, size = viewedColumnsKey.length; i < size; i++) {
      //       if (this.gridColumns[j].text == viewedColumnsKey[i]) {
      //         let viewdColumnObject = {};
      //         viewdColumnObject.text = viewedColumnsKey[i];
      //         viewdColumnObject.isHidden = viewedColumns[viewedColumnsKey[i]];
      //         newGridColumns.push(viewdColumnObject);
      //         break;
      //       }
      //     }
      //   }
      //   this.gridColumns = newGridColumns;
      //   this.columnsCase.data_list = this.gridColumns;
      // }
    }
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR",
      "PAGINATION",
      "PAGINATOR",
      "PAGE_ARROW",
      "GET_ACCOUNT_DATA",
      "GET_FEEDBACK_LIST_DATA",
      "GET_CASE_SUB_TYPE_LIST",
      "GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA",
      "GET_LANG"
    ])
  },

  methods: {
    getPrivilegeRole: function(privilegeId) {
      return utils.getPrivilegeRole(this.GET_ACCOUNT_DATA, privilegeId);
    },
    getStatusName: function(value) {
      let index = this.feedbackStatusList.findIndex(x => x.value === value);
      return index != -1 ? this.feedbackStatusList[index].text : "";
    },
    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    },
    onColumnSelect: function(tables) {
      let tableDataObj = {};
      let tableDataObjChild = {};
      tableDataObjChild["tablename"] = "caselist";
      tables.data_list.forEach(element => {
        tableDataObj[element.text] = element.isHidden;
      });
      tableDataObjChild["tablerow"] = tableDataObj;
      this.SAVE_CUSTOMIZE_TABLE_PERSONAL_CONFIG(tableDataObjChild)
        .then(function() {}.bind(this))
        .catch(function() {}.bind(this));
    },
    onSearchCase: function(event) {
      event.preventDefault();
      this.getFeedbackList(1);
    },
    addNew: function() {
      this.$router.push({
        name: "CaseAdd",
        params: {
          id: 0
        }
      });
    },
    onOpenEditInput: function(row) {
      let id = row.item.id;
      this.$router.push({
        name: "CaseAdd",
        params: {
          id: id
        }
      });
    },
    onConfirm: function() {
      this.isModalVisible = false;
      this.DELETE_FEEDBACK(this.originalRecordData)
        .then(
          function() {
            let currentPage = this.PAGINATION.page;
            let totalPage = this.PAGINATOR.length;
            let page =
              currentPage >= totalPage && this.gridCaseDataList.length == 1
                ? totalPage >= 2
                  ? totalPage - 1
                  : 1
                : currentPage;
            this.getFeedbackList(page);
            this.SUCCESS_TOAST();
          }.bind(this)
        )
        .catch(
          function() {
            this.ERROR_TOAST();
          }.bind(this)
        );
    },
    onPagination: function(data) {
      this.getFeedbackList(data);
    },
    closeModal() {
      this.isModalVisible = false;
    },
    onOpenDelete: function(row) {
      this.originalRecordData = row.item;
      this.isModalVisible = true;
    },
    onToggleDeleteConfirm: function(action = "show") {
      $(this.$refs[`modal-pkg-tmpl`]).modal(action);
    },
    getFeedbackList: function(page) {
      let filter = {
        params: {
          page: page,
          feedbackStatusList: this.feedbackStatusFilterList,
          code: utils.getCleanStringValue(this.search.code),
          feedbackTitle: utils.getCleanStringValue(this.search.title),
          person_in_charge: utils.getCleanStringValue(this.search.person_in_charge),
        }
      };
      this.isLoading = true;
      this.GET_FEEDBACK_LIST(filter)
        .then(
          function() {
            this.isLoading = false;
          }.bind(this)
        )
        .catch(
          function(error) {
            this.isLoading = false;
            this.ON_SHOW_TOAST();
          }.bind(this)
        );
    },
    interactAction: function(feedbackId) {
      this.$refs.feedbackInteractModal.onGetData(feedbackId);
    },
    callbackFeedback: function() {
      this.getFeedbackList(this.paginateData.currentPage);
    },
    // check on show action interact
    getShowInteractAction: function(statusValue, assigntoId, depatmentData) {
      if (
        statusValue === feedbackStatusEnum.DONE ||
        statusValue === feedbackStatusEnum.CANCELED
      ) {
        return false;
      }
      if (this.getPrivilegeRole(privilegeRoleEnum.RECEPTION)) return true;
      if (assigntoId === this.GET_ACCOUNT_DATA.id) return true;
      if (!utils.isEmptyString(depatmentData.manager_id)) {
        if (depatmentData.manager_id === this.GET_ACCOUNT_DATA.id) return true;
      }
    },
    onChangeTab: function(value) {
      this.feedbackTabSelect = value
      if (value !== null) {
        // 
        this.feedbackStatusFilterList = [
          feedbackStatusEnum.CREATE,
          feedbackStatusEnum.RECEIVED,
          feedbackStatusEnum.IN_PROGRESS,
          feedbackStatusEnum.IN_PROGRESS_DOING,
          feedbackStatusEnum.IN_PROGRESS_DONE,
          feedbackStatusEnum.IN_PROGRESS_CANCEL
        ]
      } else {
        // 
        this.feedbackStatusFilterList = [
          feedbackStatusEnum.DONE,
          feedbackStatusEnum.CANCELED
        ]
      }
      this.getFeedbackList(1)
    },
    getStatusColor: function(value) {
      if (value === feedbackStatusEnum.IN_PROGRESS_DONE) {
        return '#26BA50'
      }
      return ""
    },
    ...mapActions([
      "ON_SHOW_TOAST",
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "PAGINATION_PREV_PAGE",
      "PAGINATION_NEXT_PAGE",
      "GET_FEEDBACK_LIST",
      "DELETE_FEEDBACK",
      "SAVE_CUSTOMIZE_TABLE_PERSONAL_CONFIG",
      "GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG",
      "GET_TOKEN_UPLOAD"
    ])
  },
  mounted() {
    // fix show multiple modal
    $(document).on("hidden.bs.modal", ".modal", function() {
      $(".modal:visible").length && $(document.body).addClass("modal-open");
    });
    // 
    this.getFeedbackList(1);
    this.columnsCase.data_list = this.gridColumns;
    const filter = {
      params: {
        tablename: "caselist"
      }
    };
    this.GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG(filter);
    this.GET_TOKEN_UPLOAD();
  },

  components: {
    "lte-button": LTEButton,
    // "lte-table": LTETable,
    "lte-modal": LTEModal,
    "lte-core-alert": LTECoreAlert,
    paginator: Paginator,
    loading: Loading,
    // "select-option-check": SelectOptionCheck,
    // ConfigDepartmentAndSubject,
    FeedbackInteractModal
  }
};
</script>
<style scoped>
.panel.with-nav-tabs .panel-heading {
  padding: 5px 5px 0 5px;
}
.panel.with-nav-tabs .nav-tabs {
  border-bottom: none;
}
.panel.with-nav-tabs .nav-justified {
  margin-bottom: -1px;
}
/********************************************************************/
/*** PANEL PRIMARY ***/
.with-nav-tabs.panel-primary .nav-tabs > li > a,
.with-nav-tabs.panel-primary .nav-tabs > li > a:hover,
.with-nav-tabs.panel-primary .nav-tabs > li > a:focus {
  color: #fff;
}
.with-nav-tabs.panel-primary .nav-tabs > .open > a,
.with-nav-tabs.panel-primary .nav-tabs > .open > a:hover,
.with-nav-tabs.panel-primary .nav-tabs > .open > a:focus,
.with-nav-tabs.panel-primary .nav-tabs > li > a:hover,
.with-nav-tabs.panel-primary .nav-tabs > li > a:focus {
  color: #fff;
  background-color: #3071a9;
  border-color: transparent;
}
.with-nav-tabs.panel-primary .nav-tabs > li.active > a,
.with-nav-tabs.panel-primary .nav-tabs > li.active > a:hover,
.with-nav-tabs.panel-primary .nav-tabs > li.active > a:focus {
  color: #428bca;
  background-color: #fff;
  border-color: #428bca;
  border-bottom-color: transparent;
}
.with-nav-tabs.panel-primary .nav-tabs > li.dropdown .dropdown-menu {
  background-color: #428bca;
  border-color: #3071a9;
}
.with-nav-tabs.panel-primary .nav-tabs > li.dropdown .dropdown-menu > li > a {
  color: #fff;
}
.with-nav-tabs.panel-primary
  .nav-tabs
  > li.dropdown
  .dropdown-menu
  > li
  > a:hover,
.with-nav-tabs.panel-primary
  .nav-tabs
  > li.dropdown
  .dropdown-menu
  > li
  > a:focus {
  background-color: #3071a9;
}
.with-nav-tabs.panel-primary
  .nav-tabs
  > li.dropdown
  .dropdown-menu
  > .active
  > a,
.with-nav-tabs.panel-primary
  .nav-tabs
  > li.dropdown
  .dropdown-menu
  > .active
  > a:hover,
.with-nav-tabs.panel-primary
  .nav-tabs
  > li.dropdown
  .dropdown-menu
  > .active
  > a:focus {
  background-color: #4a9fe9;
}
.interact-action-class {
  cursor: pointer;
  color: blue;
  flex-flow: nowrap;
}
.interact-action-class:hover {
  text-decoration: underline;
}
.action-class {
  text-align: right;
}
/*  */
.customer-type-class {
  padding: 5px 15px;
  cursor: pointer;
}
.border-right {
  border-right: 1px solid #000000 !important;
}
.customer-type-select {
  font-weight: bold;
  color: #006ad4;
}
</style>



// WEBPACK FOOTER //
// src/views/Case/CaseListV2.vue